import { useContext, useMemo } from 'react';
import type { TaskStateInfoT } from '../../types';
import { TaskStateStoreContext } from '../task-state-provider';
export default function useTaskStateStore() {
  return useContext(TaskStateStoreContext);
}
export function useTaskStateInfo(): TaskStateInfoT {
  const taskStateInfo = useTaskStateStore();
  return useMemo(() => {
    const {
      hasRequiredTaskMode: _,
      ...restStore
    } = taskStateInfo;
    return restStore;
  }, [taskStateInfo]);
}